import React, { useMemo } from 'react'
import styled from 'styled-components'
import { Form } from 'react-bootstrap'

const StyleListItem = styled.div`
  cursor: pointer;
  padding: 10px 25px;
  border-bottom: 1px solid #ddd;
    &:hover {
      background-color: #ECECEC ;
    }
  ${props => props.selected && `background-color: #ECECEC ;`}
`
const StyledFlexWrapper = styled.div`
  display:flex;
  justify-content:space-between;
  align-items: center;
  width: 100%;
  .leftSide{
    display:flex;
    flex-basis:70%;
  }
  .rightSide{
    display: flex;
    justify-content: flex-end;
    flex-basis:30%;
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`
const BP = ({ onClickSelectedBPs, selectedBPs, bp, index }) => {
  const isSelected = useMemo(() => selectedBPs.map(selectedBP => selectedBP.id).includes(bp.id), [bp.id, selectedBPs])

  return (
    <StyleListItem onClick={() => onClickSelectedBPs(bp, index)}
      selected={isSelected}
    >
      <StyledFlexWrapper>
        <div className="leftSide">
          <div>
            <h3>{bp.displayName}</h3>
            <p>{bp.articleNumber}</p>
          </div>
        </div>
        <div className="rightSide">
          <Form.Check
            type="checkbox"
            id={`bp-${bp.id}`}
            name="bp.selected"
            checked={isSelected}
            onChange={() => onClickSelectedBPs(bp, index)}
          />
        </div>
      </StyledFlexWrapper>
    </StyleListItem>
  )
}

export default BP